import React from 'react'
import blogone from "../../../../assets/images/blogone.jpg";
import blogtwo from "../../../../assets/images/customerbooking.jpg";
import blogthree from "../../../../assets/images/blogthree.jpg";
import { Link } from 'react-router-dom';


interface MyComponent {
    sectionData: any;
}
const RecentPost: React.FC<MyComponent> = ({ sectionData }) => {
    const blogo_image = [blogone, blogtwo, blogthree];
    console.log(sectionData);

    return (
        <div className='recent_post_block'>
            <span className='heading'>Recent Post</span>
            <div className='blog_post'>
                {sectionData?.map((item: any, index: number) => {
                    return (
                        <div key={index} className='blogo_list'>
                            <div className='image'>
                                <img src={blogo_image[item.id - 1]} alt="logos" />
                            </div>
                            <div className='content'>
                                <Link to={`/blog/${item.ur}`} className='title'>{item.title}</Link>
                                {item.date}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    )
}

export default RecentPost
